module.exports = __webpack_public_path__ + "static/media/19.e07ae524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/19.jpg
// module id = 180
// module chunks = 0